import axios from "axios";
import { COURT_RECORD_DATA_FAILED, COURT_RECORD_DATA_LOADING, COURT_RECORD_DATA_SUCCESS, COURT_RECORD_SAVE_DATA_FAILED, COURT_RECORD_SAVE_DATA_LOADING, COURT_RECORD_SAVE_DATA_SUCCESS } from "../Constants/CourtRecordCheckConstants";
import { FOLDERPATH } from "../Constants/config";
import { handleApiError } from "../Helper/actionHelper";
import { GET_FORM16_DATA_FAILED, GET_FORM16_DATA_LOADING, GET_FORM16_DATA_SUCCESS } from "../Constants/form16Constants";
import { toast } from "react-toastify";

export const getForm16CheckData = (callback=()=>{}) => async (dispatch) => {
    try {
      let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));
      dispatch({ type: GET_FORM16_DATA_LOADING });
      const requestData = {
        token: userLocalData.id,
        group: 23,
        // referenceNo: "1234567890",
      };
  
      const headers = {
        "Content-Type": "application/json",
        Username: "ibridge",
        Password: "ibridge@2020",
      };
  
      const { data } = await axios.post(
        FOLDERPATH + "/CandidateApi/checkDetail",
        requestData,
        {
          headers: headers,
        }
      );
  
      dispatch({
        type: GET_FORM16_DATA_SUCCESS,
        payload: data,
      });
      callback(data?.data);
  
      handleApiError(data); //in case API return 200 with error details
    } catch (error) {
        let errorMsg = error.message;
      toast.error(errorMsg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      dispatch({
        type: GET_FORM16_DATA_FAILED,
        payload:
          error.response && error.response.data.message
            ? error.response
            : error.response,
      });
  
      handleApiError(error);
    }
  };

export const saveForm16Data = (payload, callback=()=>{}) => async (dispatch) => {
    try{
        let userLocalData = JSON.parse(localStorage.getItem('userVerificationCandidate'));  

        dispatch({type : COURT_RECORD_SAVE_DATA_LOADING});

        const requestData = {
            token: userLocalData?.id,
            ...payload
        }

        const headers = {
            "Content-Type": "application/json",
            Username: "ibridge",
            Password: "ibridge@2020",
          };

        // const {data} = await axios.post(FOLDERPATH + "/NewSigndriveApi/saveDeclarationDetails" , requestData, {headers: headers});
        const { data } = await axios.post(FOLDERPATH + 
          "/CandidateApi/saveCheckDetails",
          requestData,
          {
            headers: headers,
          } 
        );
        
        dispatch({
            type : COURT_RECORD_SAVE_DATA_SUCCESS,
            payload : data
        })
        callback(data?.data);

        handleApiError(data);

    } catch (error) {
        dispatch({
            type: COURT_RECORD_SAVE_DATA_FAILED,
            payload:
            error.response && error.response.data.message
              ? error.response
              : error.response,  
        })

        handleApiError(error);

    }
}